module.exports = __webpack_public_path__ + "img/qy.5a314c3a.png";